export default __webpack_public_path__ + "assets/gallery-2.png";